export enum DatalayerEvents {
    Share = 'share',
    Sign_Up = 'sign_up',
    EO_submit = 'eo_submit'
}
